<template>
  <div>
    <NavigationBreadcrumb :items="breadcrumb_items"></NavigationBreadcrumb>
    <div>
      <h3 class="title-header noprint mt-3">
        {{
          $getVisibleNames(
            "manual.actividad_presencial",
            true,
            "Actividades Presenciales"
          )
        }}
        <AlternativeNameButton
          :table_name="'manual.actividad_presencial'"
          :allows_crud="allows_crud"
        ></AlternativeNameButton>
      </h3>
      <div style="display: flex">
        <div class="col" style="text-align: left">
          <ButtonMedium
            v-can="'mesh.add_directteachingactivity'"
            v-if="allows_crud"
            :tooltip_text="
              $t('reusable.common.addTooltip', {
                entity: $getVisibleNames(
                  'manual.actividad_presencial',
                  false,
                  'Actividad Presencial'
                ),
              })
            "
            :text_button="$t('reusable.common.add')"
            :click_button="
              () => $bvModal.show(`new-direct-teaching-activity-modal`)
            "
            :icon="'plus'"
            :variant="'primary'"
          >
          </ButtonMedium>
        </div>
      </div>
      <GenericBTable
        :items="direct_teaching_activities"
        :fields="directTeachingActivityFields"
        :filter="input_search"
        :filterCustom="filterCustom"
        @emitChangeSearchField="changeInputSearch"
        :show_pagination="true"
        :search_filter="true"
        :columns_display="true"
        :allows_crud="allows_crud"
        :display_id="'direct_teaching_activities'"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
      >
        <template #cell(description)="row">
          <RenderVHtml :content="row.item.description"></RenderVHtml>
        </template>
        <template v-if="allows_crud" #cell(actions)="row">
          <ButtonSmall
            v-can="'mesh.change_directteachingactivity'"
            :tooltip_text="$t('toolbar.directTeachingActivity.editActivity')"
            :click_button="
              () =>
                $bvModal.show(
                  `edit-direct-teaching-activity-modal-${row.item.id}`
                )
            "
            :class="``"
            :icon="'square'"
          ></ButtonSmall>
          <ButtonSmall
            v-can="'mesh.delete_directteachingactivity'"
            :click_button="
              () => askForDeleteDirectTeachingActivity(row.item.id)
            "
            :tooltip_text="$t('toolbar.directTeachingActivity.deleteActivity')"
            :icon="'trash'"
          ></ButtonSmall>
          <b-modal
            :id="`edit-direct-teaching-activity-modal-${row.item.id}`"
            :title="$t('toolbar.directTeachingActivity.editActivity')"
            size="lg"
            hide-footer
          >
            <DirectTeachingActivityForm
              :DirectTeachingActivity="row.item"
              @updated="slotUpdatedDirectTeachingActivity"
              :institution_id="row.item.school"
              :show_title="false"
            ></DirectTeachingActivityForm>
          </b-modal>
        </template>
      </GenericBTable>
    </div>
    <b-modal
      :id="`new-direct-teaching-activity-modal`"
      :hide-footer="true"
      :title="
        $t('reusable.common.createModalTitle', {
          entity: $getVisibleNames(
            'manual.actividad_presencial',
            false,
            'Actividad Presencial'
          ),
        })
      "
      size="lg"
    >
      <DirectTeachingActivityForm
        v-if="user"
        @created="slotCreatedDirectTeachingActivity"
        :institution_id="user.school"
      ></DirectTeachingActivityForm>
    </b-modal>
  </div>
</template>
<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { toast } from "@/utils/utils";

export default {
  name: "DirectTeachingActivityView",
  components: {
    DirectTeachingActivityForm: () => import("./DirectTeachingActivityForm"),
    GenericBTable: () => import("@/components/reusable/GenericBTable"),
    AlternativeNameButton: () =>
      import("@/components/reusable/AlternativeNameButton"),
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
    ButtonMedium: () =>
      import("@/components/reusable/Buttons/Medium/ButtonMedium"),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
    NavigationBreadcrumb: () =>
      import("@/components/reusable/NavigationBreadcrumb"),
  },
  data() {
    return {
      input_search: "",
      sortBy: "",
      sortDesc: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      direct_teaching_activities: names.DIRECT_TEACHING_ACTIVITIES,
    }),
    breadcrumb_items() {
      return [
        { text: this.$t("reusable.breadcrumb.home"), to: "/home" },
        {
          text: this.$getVisibleNames(
            "manual.actividad_presencial",
            true,
            "Actividades Presenciales"
          ),
        },
      ];
    },
    allows_crud() {
      const has_permission = this.$hasPermissions(
        "mesh.add_directteachingactivity"
      );
      if (has_permission) return has_permission;
      else return false;
    },

    directTeachingActivityFields() {
      return [
        {
          key: "name",
          label: String(
            this.$getVisibleNames(
              "manual.actividad_presencial",
              true,
              "Actividades Presenciales"
            )
          ),
          sortable: true,
          tdClass: "text-left",
          display_column: true,
        },
        {
          key: "description",
          label: this.$t("reusable.common.description"),
          sortable: true,
          display_column: true,
          tdClass: "text-left",
        },
        {
          key: "actions",
          label: "",
          display_column: true,
          thClass: "noprint",
          tdClass: "noprint",
        },
      ];
    },
  },
  methods: {
    filterCustom(row) {
      if (
        this.$filtered(row.name, this.input_search) ||
        this.$filtered(row.description, this.input_search)
      ) {
        return true;
      } else return false;
    },
    changeInputSearch(input_search) {
      this.input_search = input_search;
    },
    slotCreatedDirectTeachingActivity() {
      this.$bvModal.hide("new-direct-teaching-activity-modal");
    },
    slotUpdatedDirectTeachingActivity(direct_teaching_activity) {
      this.$bvModal.hide(
        `edit-direct-teaching-activity-modal-${direct_teaching_activity.id}`
      );
    },
    askForDeleteDirectTeachingActivity(direct_teaching_activity_id) {
      this.$swal({
        title: this.$t(
          "toolbar.directTeachingActivity.deleteActivityConfirmation"
        ),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch(
              names.DELETE_DIRECT_TEACHING_ACTIVITY,
              direct_teaching_activity_id
            )
            .then(() => {
              toast(this.$t("toolbar.directTeachingActivity.activityDeleted"));
            });
        }
      });
    },
  },
  beforeDestroy() {
    this.$store.commit(names.MUTATE_DELETE_FILTER_INTELLIGENCE);
    this.$store.commit(names.MUTATE_SHOW_INTELLIGENCE_SIDEBAR, false);
    this.$store.commit(names.MUTATE_DELETE_RULES_FILTER_SELECTOR);
  },
  mounted() {},
  created() {
    this.sortBy = "name";
    this.$store.dispatch(names.FETCH_DIRECT_TEACHING_ACTIVITIES);
    this.$nextTick(() => {
      this.$store.commit(names.MUTATE_SHOW_INTELLIGENCE_SIDEBAR, true);
      this.$store.commit(names.MUTATE_RULES_FILTER_SELECTOR, {
        visible_intelligence_options: [7],
        disabled_selected_intelligence_option: true,
      });
      this.$store.commit(names.MUTATE_FILTER_INTELLIGENCE, {
        intelligence_option: 7,
      });
    });
  },
};
</script>

<style scoped>
.title-header {
  padding: 0 2rem;
}
.btn-add {
  margin-left: 0.4rem;
  margin-bottom: 0.5rem;
  border-radius: 8px;
  width: 255px;
}
</style>